

import { connect } from 'react-redux'
import React, { useState } from 'react'
import fileIcon from '../images/file-earmark-arrow-down.svg';
import { fetchResultsPdfThunk } from '../actions/api';
import { POSITIVE, NEGATIVE } from '../api/mappers/labResultMapper';
import { Redirect } from 'react-router-dom'
import { setErrorState } from '../actions/api';

const DownloadPDFButton = (props) => {
    const { selectedResult, dispatch, isHidden, history, strings } = props;
    const [sendLoginAlert, setSendLoginAlert] = useState(false);

    const doDownloadPdf = () => {
        dispatch(fetchResultsPdfThunk())
            .catch(err => {
                if (err) {
                    if (['ARE', 'ADE'].includes(err.code)) {
                        setSendLoginAlert(true);
                    } else if (['SIE', 'MIE', 'LREE', 'DAE', 'PVE'].includes(err.code)) {
                        dispatch(setErrorState(true, err.message, true));
                    } else {
                        history.push("/");
                    }
                }
            });
    }

    if (sendLoginAlert) {
        return <Redirect to={{
            pathname: "/",
            state: { loginAlert: sendLoginAlert }
        }} />
    }

    if ((selectedResult && ![POSITIVE, NEGATIVE].includes(selectedResult.result))) {
        return <></>;
    } else {
        return (
            <div className={"printButton " + (isHidden ? "hide-print" : "")}>
                <button
                    class={"btn btn-download"}
                    onClick={() => doDownloadPdf()}
                >
                    <img src={fileIcon} width="18px" />&nbsp;
                    {strings.DOWNLOAD_PDF_BUTTON}
                </button>
            </div>
        );
    }

}


const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        deviceType: state.api.deviceType,
        selectedResult: state.api.selectedLabResult
    }
}

export default connect(mapStateToProps)(DownloadPDFButton)
